<template>
  <div>
    <div class="modal__show-btn" @click="showModal">
      modal (イメージとテキスト) (セカンダリーボタン) 表示
    </div>
    <TextImageModalWithSecondary
      v-if="showableModal"
      :image-url="imageUrl"
      :title-text="'タイトルが入ります'"
      :caption-text="
        'キャプションエリアです。\n詳細事項を手短に書いてください。'
      "
      :primary-button-text="'変更する'"
      :secondary-button-text="'セカンダリーボタン'"
      :cancel-button-text="'閉じる'"
      @clicked-modal-cover="closeModal"
      @clicked-primary="clickedPrimary"
      @clicked-secondary="clickedSecondary"
      @clicked-cancel="closeModal"
    />
  </div>
</template>

<script>
import TextImageModalWithSecondary from '../../components/molecules/modals/with_secondary/text-image-modal-with-secondary.vue'
import imageUrl from '../../../../images/styleguide/sample_modal_image_2.png'

export default {
  components: { TextImageModalWithSecondary },
  data() {
    return {
      showableModal: false,
      imageUrl
    }
  },
  methods: {
    showModal() {
      this.showableModal = true
    },
    closeModal() {
      this.showableModal = false
    },
    clickedPrimary() {
      window.alert('clicked primary button!')
      this.closeModal()
    },
    clickedSecondary() {
      window.alert('clicked secondary button!')
      this.closeModal()
    }
  }
}
</script>
